import React, { useEffect, useState } from "react";
import { Tabs, Tab, MenuItem, Select,styled, FormControl, InputLabel, Backdrop, CircularProgress} from "@mui/material";
import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import api from "../../api/api";
import dayjs from "dayjs";
import ToastMessage from "../../utils/mui/righttoptoast";
const Schedularpopup = ({ isOpen, onClose, data }) => {

  const [provider, setProvider] = useState("");
  const [appointmentType, setAppointmentType] = useState("");
   const [openToast, setOpenToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastSeverity, setToastSeverity] = useState('success');
  const [selectedDate, setSelectedDate] = useState(dayjs());  // State for the selected date
  const[loading,setLoading]=useState(false)
  const[tableData,setTableData]=useState([])
const [providername,setProvidername]=useState('')
const[appointmentname,setAppointmentName]=useState('')
const[slotsdata,setSlotsData]=useState([])
const [selectedSlot,setSelectedSlot]=useState('')
  const [providersList,setProviderslist]=useState([])
  const[appointmenttypes,setAppointmentTypes]=useState([])
  const [deleteloading,setDeleteloading]=useState(false)
  const[createloading,setCreateLoading]=useState(false)
  const [rescheduleSelectedDate, setRescheduleSelectedDate] = useState(dayjs()); // New state for the reschedule date
  const practiseid = window.getPracticeId();
const [appdates,setAppDates]=useState('')

  const CustomDateCalendar = styled(DateCalendar)(({ theme }) => ({
    '& .MuiPickersCalendarHeader-label': {
      fontSize: '15px',
    },
    '& .MuiPickersArrowSwitcher-button': {
      outline: 'none',
      boxShadow: 'none',
      '&:focus': {
        outline: 'none',
        boxShadow: 'none',
      },
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
    // Targeting the selected day, including the disabled state
    '& .MuiPickersDay-root.Mui-selected': {
      backgroundColor: '#E17954 !important',
      // Change text color to white for contrast
      '&:hover': {
        backgroundColor: '#E17954 !important', // Keep the orange even on hover
      },
    },
  }));

const clearAllStates = () => {
    setProvidername('');
    setAppointmentName('');
    setProvider('');
    setAppointmentType('');
    setSelectedSlot('');
};
  
const getProviders=async()=>{
  try {
    const response=await api.get(`/v1/${practiseid}/providers`)
    if(response.status===200){
      setProviderslist(response.data)

      const providerIds = response.data.map(provider => provider.providerid);
      const appresponse=await api.post(`/v1/${practiseid}/appointment/types`,{
        "providerid":providerIds
    
    })
  
    if(appresponse.status===200){
     setAppointmentTypes(appresponse.data)
     if(appresponse?.data?.length){
      setAppointmentType(appresponse?.data[0]?.value)
      setAppointmentName(appresponse?.data[0]?.appointmenttypeid)
   
     }
    
    }else{
      setAppointmentTypes([])
    }
    }else{
      setProvider([])
    }
    if(response?.data?.length){
      setProvider(response?.data[0]?.providerid)
      setProvidername(response?.data[0]?.providername)
      await getslots(response?.data[0]?.providerid,selectedDate.format('YYYY-MM-DD'))
          }


  } catch (error) {
    
  }finally{
  }
}

const getslots=async(id,dt)=>{
  console.log("id",id)
    try {
      const response=await api.post(`/v1/${practiseid}/scheduler/openslots`,{
     "providerid": id,
      "startdate": dt
      })
      if(response.status===200){
       
        setSlotsData(response.data)
      }else{
        setSlotsData([])
      }
    } catch (error) {
      console.log(error)
    }
}

const providerChange=(e)=>{
const selectedProvider = providersList.find(
  (item) => item.providerid == e
)
setProvider(e)
setProvidername(selectedProvider?.providername)
getslots(e,selectedDate.format('YYYY-MM-DD'))
}
const appointmentChange=(e)=>{
  setAppointmentType(e)
  const selectedAppointmentname=appointmenttypes.find((item)=>item.value==e)
setAppointmentName(selectedAppointmentname?.appointmenttypeid)
}

  const handleDateChange = async(newDate) => {

    setSelectedDate(newDate);  // Update the selected date state
    await getslots(providersList[0]?.providerid,newDate.format('YYYY-MM-DD'))
};

  const handleToastClose = () => {
    setOpenToast(false)
};

const fetchdata=async(dt)=>{
  setLoading(true)
try {
  const appointmentsdata=await api.get(`/v1/${practiseid}/appointments/${data?.patientid}/future`
  //   ,{
  // "scheduledate": dt
  // }
)
 const datesresp=await api.get(`/v1/${practiseid}/appointments/last-future/${data?.patientid}`)
    if(datesresp.status==200){
setAppDates(datesresp?.data)
    }else{
      setAppDates('')
    }
if(appointmentsdata.status===200){
  setTableData(appointmentsdata.data)
}else{
  setTableData([])
}
  
} catch (error) {
  console.log(error)
}finally{
  setLoading(false)
}

}





const createappointment=async()=>{

  if(!appointmentType){
    setToastMessage('Please Select Appointment Type');
  setToastSeverity('error');
  setOpenToast(true);
  return
  }
if(!provider){
  setToastMessage('Please Select Provider');
  setToastSeverity('error');
  setOpenToast(true);
  return
}
if (!selectedSlot) {
  setToastMessage('Please Select Time Slot');
  setToastSeverity('error');
  setOpenToast(true);
  return;
}
try {
  setCreateLoading(true)
  const response=await api.post(`/v1/${practiseid}/scheduler/patient/${data?.patientid}/create_schedule`,{
    "departmentid": data?.departmentid,
    "startdate": selectedDate.format('YYYY-MM-DD'),
    "starttime": selectedSlot,
    "provider": providername,
    "providerid": provider,
    "appointmenttype": appointmentType,
    "appointmenttypeid": appointmentname,
    "notes": ""
    
})
if(response.status==200){
  setToastMessage('schedule created successfully');
  setToastSeverity('success');
  setOpenToast(true);
  setTimeout(() => {
    clearAllStates()
    onClose(false);
  }, 1200); // 1200ms = 1.2 secon
}else{
  setToastMessage('Failed to create schedule. Please try again.');
  setToastSeverity('info');
  setOpenToast(true);
}
  
} catch (error) {
  console.log(error)
  setToastMessage('Something Went Wrong');
  setToastSeverity('error');
  setOpenToast(true);
}finally{
setCreateLoading(false)


}

}

useEffect(()=>{
  if(isOpen){
   fetchdata(selectedDate.format('YYYY-MM-DD')) 
   getProviders()
   
  }

},[isOpen])

const deleteAppointment=async(val)=>{
setDeleteloading(val)
console.log('iddcs',val)
try {
  const response=await api.delete(`/v1/${practiseid}/scheduler/cancelschedule`,{
   data: {
      "rowid": val,
      "notes": "test delete"
    }}
  )
  
  if(response.status==200){
    setToastMessage("schedule cancelled successfully");
    setToastSeverity('success');
    setOpenToast(true);

    fetchdata()
  }else{
    setToastMessage('Failed to Cancel schedule. Please try again.');
    setToastSeverity('info');
    setOpenToast(true);
  }
  
} catch (error) {
  console.log(error)
  setToastMessage('Something Went Wrong');
  setToastSeverity('error');
  setOpenToast(true);
}finally{
  setDeleteloading(false)
}

}
console.log('selectedSlot',selectedSlot)

const rescheduleAppointment = async (patientId,appointmentid,current_startdate) => {
  setLoading(true);
  try {
    const res = await api.post(`/v1/${practiseid}/scheduler/patients/${patientId}/rescheduleappointment`, {
      appointmentid: appointmentid,
      current_startdate: current_startdate,
      new_startdate:selectedDate.format('YYYY-MM-DD'),
      new_starttime:`${selectedSlot}:00`,
    });

    if (res.status === 200) {
      fetchdata()
      console.log('Appointment rescheduled successfully');
      setToastMessage('Appointment rescheduled successfully');
      setToastSeverity('success');
      setOpenToast(true);
      setTimeout(() => {
        clearAllStates();
        onClose(false);
      }, 1200);
    } else {
      console.log('Failed to reschedule appointment');
      setToastMessage('Failed to reschedule appointment');
      setToastSeverity('info');
      setOpenToast(true);
    }
  } catch (error) {
    console.log('Error rescheduling appointment:', error);
    setToastMessage('Something Went Wrong');
    setToastSeverity('error');
    setOpenToast(true);
  } finally {
    setLoading(false);
  }
};

  const isProviderMatched = (typeof provider === 'string' && 
    (provider.includes("Leanora") || 
     provider.includes("Reshma") || 
     ['15', '17'].includes(provider))) ||
    (Array.isArray(provider) && provider.some(p => p === "Leanora" || p === "Reshma"));

  if (!isProviderMatched) {
    console.log("No matching provider found.");
  }

  return (
    isOpen && (
      <>
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="relative flex flex-col gap-4 w-[400px] sm:w-[80%] bg-white px-4 pb-6 rounded-lg shadow-lg text-left">
            <div>
              <div className="w-full flex items-center justify-between mt-2">
                <span className="ml-2 font-semibold text-[#1D2951] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
                <div  className="flex">
                  <div className="border-4 border-[#FED7AA]  rounded-full">
                  <img
                      src={`/cloud-assets/chim/public/assets/images/profilepictures/${data?.patientid}.png`}
                      alt="User"
                      className="w-10 h-10 rounded-full border-2 border-[#FED7AA]"
                    />
                  </div>
               
                    <div className="text-center  pl-2">
                      <div className="text-[16px] font-semibold text-left">{`${data?.firstname} ${data?.lastname}`}</div>

                      <div className="flex text-xs text-[#6B7280] items-end">
                      <div  className="mr-1">  #{data?.patientid}</div> | 
                      <div className="ml-1">DOB: {data?.dob}</div>
                      </div>

                    </div>
                  </div>
                </span>
  <div className="flex flex-col">
                  <div className="flex gap-2 items-center">
                  <p className="text-[#6B7280] font-inter text-[13px] my-0">Last Appointment: </p>
                 <p className="text-[#6B7280] text-[12px] font-inter text-xs my-0">
  {appdates?.last_appointment?.startdate
    ? dayjs(appdates.last_appointment.startdate).format('MM-DD-YYYY hh:mm A')
    : 'No last Appointment'}
</p>

                  </div>
                  <div className="flex gap-2 items-center">
                  <p className="text-[#6B7280] font-inter text-[13px] my-0">Next Appointment:</p>
               <p className="text-[#6B7280] text-[12px] font-inter text-xs my-0">
  {appdates?.future_appointment?.startdate
    ? dayjs(appdates.future_appointment.startdate).format('MM-DD-YYYY hh:mm A')
    : 'No last Appointment'}
</p>

                  </div>
                </div>
                <button
                  className="text-gray-500 hover:text-gray-700 text-[30px]"
                  onClick={() =>{

                    clearAllStates()
                  onClose(false)}}
                >
                  &times;
                </button>
              </div>
              <div className="flex flex-col sm:flex-row ">
                <div className="w-full sm:w-2/6 flex flex-col  space-y-6 p-2 mr-2 mt-2">
                  {/* User Info Box */}
              
                  <div className=" flex flex-col sm:flex-row gap-4 ">
                          <div>
                            <div className="bg-gray-white border-2 rounded-md text-center ">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <CustomDateCalendar
                                value={selectedDate}  // Pass selected date as the value
                                onChange={handleDateChange}  // Handle date change 
                                minDate={dayjs()} 
                              />
                                </LocalizationProvider> 
                            </div>
                          </div>

                          {/* Time Slot Section */}
                          
                        </div>
                </div>

                {/* MUI Tabs Section */}
                <div className="flex-grow p-4">
            

                  <div className="mt-4 w-full">
                      <div className="flex flex-col gap-4 w-full">
                        <div className="flex gap-4 w-full flex-column">
                          <div className="flex gap-4 px-[16px]">
                          <div className="flex flex-col w-[30%]">
  <label htmlFor="providers" className="text-sm mb-1 text-gray-600">
    Providers
  </label>
  <select
    id="providers"
    value={provider}
    onChange={(e) => providerChange(e.target.value)}
    className="h-10 px-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
  >
  
    {providersList.map((providerItem) => (
      <option key={providerItem.providerid} value={providerItem.providerid}>
        {providerItem.providername}
      </option>
    ))}
  </select>
</div>
<div className="flex flex-col w-[30%]">
  <label htmlFor="appointmentType" className="text-sm mb-1 text-gray-600">
    Appointment Type
  </label>
  <select
    id="appointmentType"
    value={appointmentType}
    onChange={(e) => appointmentChange(e.target.value)}
    className="h-10 px-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
  >
    <option value="" disabled>
      Select Appointment Type
    </option>
    {appointmenttypes.map((type, index) => (
      <option key={index} value={type?.value}>
        {type?.value}
      </option>
    ))}
  </select>

</div>
                            </div>
                          {/* Providers Dropdown */}

<div className="flex flex-col w-full mt-2">
<div className="flex flex-wrap gap-2 w-full items-center justify-center">
  {slotsdata.length === 0 ? (
    <p className="text-md text-gray-500 bg-gray-100 px-4 py-2 rounded">No open slots available for this provider!</p>
  ) : (
    slotsdata.map((slot) => (
     <button
  onClick={() => setSelectedSlot(slot.starttime)}
  key={slot.starttime}
  className={`px-4 py-2 text-sm font-semibold border-[1.5px] border-[#50869A] rounded-md
    ${slot.appointment_count <= 2
      ? 'bg-[#DCFCE7]'
      : slot.appointment_count <= 4
      ? 'bg-[#FFEDD4]'
      : 'bg-[#FFE2E2]'}
    ${selectedSlot === slot.starttime ? ' text-[#50869A] bg-gray-200' : 'hover:bg-gray-200 text-[#50869A]'}
    focus:ring-2 focus:ring-gray-200 focus:outline-none`}
    disabled={slot.appointment_count >= 1}
>
  {slot.starttime}
  {slot.appointment_count > 0 && (
    <span className="ml-2 font-normal ">({slot.appointment_count})</span>
  )}
</button>

    ))
  )}
</div>

    <div className="mt-4">


{/* Create Appointment Button */}

<div className=" flex justify-center w-full">
  {createloading ? (
    // Show a loading spinner or message while the action is in progress
    <div className="flex items-center">

      <span className="text-blue-500">Creating Appointment...</span>
    </div>
  ) : (
    // Render the button when not loading
    <button
      onClick={() => createappointment()}
      className="px-6 py-2 bg-[#F97316] w-[93%] text-white rounded-md hover:bg-black focus:ring-2 focus:ring-blue-500 focus:outline-none"
    >
      Create Appointment
    </button>
  )}
</div>


</div>
  </div>

                          {/* Appointment Types Dropdown */}




                        </div>

                        {/* Calendar Section */}
                    
                      </div>
             
           

           
                  </div>
                </div>
              </div>
              <div className="px-1 font-semibold font-Font1 ml-1">Upcoming appointments</div>
              <div className="overflow-y-auto max-h-[150px]">
  {loading ? (
    <div className="text-center text-blue-500 animate-pulse">
      Loading data, please wait...
    </div>
  ) : tableData && tableData.length > 0 ? (
    <div className="grid grid-cols-2 gap-4 p-2">
      {tableData.map((row, index) => (
        <div
          key={index}
          className="bg-white border border-gray-300 p-4 mb-4 flex flex-col rounded-[10px] hover:bg-gray-100"
        >
          <div className="flex flex-col space-y-2">
          <div className="flex gap-2">
          <span className="text-[13px] font-semibold">
      {row.startdate ? dayjs(row.startdate).format('MM-DD-YYYY') : "N/A"}
        </span>
        <span className="text-[13px] font-semibold">
  {row.starttime ? dayjs(row.starttime, "HH:mm:ss").format('hh:mm A') : "N/A"}
</span>

            </div>
            <div className="flex gap-1 text-[#4B5563] text-[13px]">
              <span>{row.providername || "N/A"}</span>-
              <span>{row.type || "N/A"}</span>
  
            </div>
       
       
            <div className="flex gap-2">
              <button
                onClick={() => deleteAppointment(row.id)}
                disabled={deleteloading === row.id}
                className={`flex items-center text-white bg-[#FEF2F2] border  px-2 py-1 text-sm rounded shadow-sm `}
              >
                {/* {deleteloading === row.id ? (
                  <span className="text-md animate-spin">⏳</span>
                ) : (
                  <span className="font-bold text-xs">❌</span>
                )} */}
                <span className="text-[#DC2626]" >Cancel</span>
              </button>
              {/* <button
               onClick={()=>rescheduleAppointment(row.patientid,row.appointmentid,row.start_date)}
                className={`flex text-[#EA580C] items-center bg-[#FFF7ED] border  px-2 py-1 text-sm rounded shadow-sm `}
>
                Reschedule
              </button> */}
            </div>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div className="text-center text-gray-500">
      No data available
    </div>
  )}
</div>

            </div>
          </div>
        </div>
        <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
        <Backdrop
                       sx={{
                         color: 'secondary.main', // Sets the CircularProgress color to secondary
                         backgroundColor: 'rgba(255, 255, 255, 0.5)', // Semi-transparent white background
                         zIndex: (theme) => theme.zIndex.drawer + 1
                       }}
                       open={loading}
                     >
                       <CircularProgress color="secondary" />
                     </Backdrop>
      </>
    )
  );
};

export default Schedularpopup;
